"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ReleaseWorkflowType_1 = require("../../../release/model/ReleaseWorkflowType");

var SelloutReleaseType_1 = require("../../../release/model/sellout/SelloutReleaseType");
/**
 * Contains data necessary for one row (item) of report of terminated sellout prices.
 *
 * @author Jan Prokop
 */


var SelloutTerminationReportRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutTerminationReportRowDTO, _DomainObject_1$Domai);

  /**
   * TODO (JS1): validate documentation and optionality of attributes.
   *
   * @param productExternalId     Gold ID
   * @param productName           Product name
   * @param siteExternalId        External site ID
   * @param siteName              Site Name
   * @param endDate               Date of sellout price termination.
   * @param reason                Reason of termination as text for now, will be displayed as is.
   * @param selloutPrice          Sellout price already rounded
   * @param priceValidFrom        Original sellout price validity from
   * @param priceValidTo          Original sellout price validity end
   * @param releaseType           Type of sellout of terminated price
   * @param newSelloutTypes       Price can be replaced by another one from a sellout with higher priority. The newly identified sellout
   *                              types are here.
   * @param releaseId             Id of release of terminated price
   * @param releaseName           Name of release of terminated price
   * @param releaseWorkflowType   Workflow type of release of terminated price
   */
  function SelloutTerminationReportRowDTO(productExternalId, productName, siteExternalId, siteName, endDate, reason, selloutPrice, priceValidFrom, priceValidTo, releaseType, newSelloutTypes, releaseId, releaseName, releaseWorkflowType) {
    var _this;

    _classCallCheck(this, SelloutTerminationReportRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationReportRowDTO).call(this));
    _this.productExternalId = productExternalId;
    _this.productName = productName;
    _this.siteExternalId = siteExternalId;
    _this.siteName = siteName;
    _this.endDate = endDate;
    _this.reason = reason;
    _this.selloutPrice = selloutPrice;
    _this.priceValidFrom = priceValidFrom;
    _this.priceValidTo = priceValidTo;
    _this.releaseType = releaseType;
    _this.newSelloutTypes = newSelloutTypes;
    _this.releaseId = releaseId;
    _this.releaseName = releaseName;
    _this.releaseWorkflowType = releaseWorkflowType;
    return _this;
  }

  _createClass(SelloutTerminationReportRowDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutTerminationReportRowDTO(mat.productExternalId, mat.productName, mat.siteExternalId, mat.siteName, mat.endDate, mat.reason, mat.selloutPrice, mat.priceValidFrom, mat.priceValidTo, mat.releaseType, mat.newSelloutTypes, mat.releaseId, mat.releaseName, mat.releaseWorkflowType);
    }
  }]);

  return SelloutTerminationReportRowDTO;
}(DomainObject_1.DomainObject);

exports.SelloutTerminationReportRowDTO = SelloutTerminationReportRowDTO;

SelloutTerminationReportRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutTerminationReportRowDTO.name);
  return {
    productId: builder.id('productId'),
    productExternalId: builder.str('productExternalId'),
    productName: builder.str('productName'),
    siteExternalId: builder.str('siteExternalId'),
    siteName: builder.str('siteName'),
    endDate: builder.date('endDate', DateParser_1.DateParser.ISO_PATTERN),
    reason: builder.str('reason'),
    selloutPrice: builder.bigNum('selloutPrice'),
    priceValidFrom: builder.date('priceValidFrom', DateParser_1.DateParser.ISO_PATTERN),
    priceValidTo: builder.opt(builder.date('priceValidTo', DateParser_1.DateParser.ISO_PATTERN)),
    releaseType: builder.senum('releaseType', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType),
    newSelloutTypes: builder.opt(builder.listOf(builder.senum('newSelloutTypes', SelloutReleaseType_1.SelloutReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.SelloutReleaseType))),
    releaseId: builder.str('releaseId'),
    releaseName: builder.str('releaseName'),
    releaseWorkflowType: builder.senum('releaseWorkflowType', ReleaseWorkflowType_1.ReleaseWorkflowType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseWorkflowType)
  };
}();